import { render } from "./SnippetNavigation.vue?vue&type=template&id=08f92d5c&bindings={\"file\":\"props\",\"theme\":\"setup\",\"formatDate\":\"setup\"}"
import script from "./SnippetNavigation.vue?vue&type=script&lang=js"
export * from "./SnippetNavigation.vue?vue&type=script&lang=js"
script.render = render

export default script